import { CpPlansConsentsModal } from './cp-plans-consents-modal';

export class CpConsentsRequestConsentModal extends CpPlansConsentsModal {
  checked: boolean = false;
  requiredForSubscription: boolean = false;

  constructor(init?: Partial<CpConsentsRequestConsentModal>) {
    super(init);
    Object.assign(this, init);
  }
}

export class CpConsentsRequestResponseModal {
  name: string = '';
  email: string = '';
  guid: string = '';
  consents: CpConsentsRequestConsentModal[] = [];

  constructor(init?: Partial<CpConsentsRequestResponseModal>) {
    Object.assign(this, init);
  }
}
